export const WEAPON = {
  id: 'pistol',
  label: 'P-19',
  class: 'pistol',
  caliber: '9x19',
  /** Free starter weapon — never enters the armory's purchase flow. */
  price: 0,
  rpm: 460,
  modes: ['semi'],
  burstCount: 1,
  burstRpm: 460,
  burstDelay: 0.1,
  magSize: 17,
  reserve: 68,
  muzzleVelocity: 360,
  damage: 28,
  penetration: 0.35,
  dropoff: 0.42,
  maxRange: 180,
  dragK: 0.46,
  tracerEvery: 5,
  spreadHip: 3.1,
  spreadAds: 0.5,
  spreadPerShot: 0.42,
  spreadMax: 4.6,
  spreadDecay: 5.2,
  recoil: {
    pitch: 0.0125,
    yaw: 0.0032,
    kickBack: 0.012,
    kickUp: 0.0105,
    roll: 0.018,
    punch: 0.3,
    freq: 9.0,
    damping: 0.45,
    patternLength: 17,
    patternSeed: 0x1f77bc,
    climbShape: [1.0],
    drift: 1.2,
  },
  adsTime: 0.16,
  adsFov: 0.86,
  viewFov: 0.92,
  reloadTac: 1.6,
  reloadEmpty: 2.2,
  inspectTime: 2.6,
  drawTime: 0.42,
  holsterTime: 0.3,
  /* A pistol is held out on the arms rather than braced on the shoulder, so
   * the hip pose is FURTHER from the eye than a carbine's and the ADS eye
   * relief is most of an arm's length. 0.34 m keeps both elbows visibly bent;
   * past ~0.40 m the two-bone solve hits full extension and they lock. */
  hipPos: [0.115, -0.15, -0.34],
  hipRot: [-0.05, 0.066, -0.115],
  adsCant: [0, 0, 0.003],
  eyeRelief: 0.34,
  sprintPos: [0.09, -0.25, -0.28],
  sprintRot: [-0.42, 0.5, 0.14],
  lowReadyPos: [0.1, -0.26, -0.32],
  lowReadyRot: [-0.44, 0.105, -0.07],
  swayScale: 1.15,
  bobScale: 1.1,
  magLen: 0.108,
};

export const loadModel = () => import('../models/pistol.js').then((m) => m.buildPistol);
